<template>
  <div class="famille needResize" :class="{'fullscreen': fullscreen}" v-if="result">
    <Info @fullscreen="onFullScreen" title="famille.title" :text="info.infoKey" ></Info>
    <div class="famille-title">
      <h3>{{$t('famille.title')}}</h3>
      <div class="title">
        <div class="metricSelector"> <v-select v-model="metricSelect" :options="metrics" :clearable="false" :searchable="false"></v-select></div>
        <div class="metricSelector"> <v-select v-model="topSelect" :options="tops" :clearable="false" :searchable="false"></v-select></div>
      </div>
      <!--h2>{{$t('famille.description')}}</h2-->
    </div>
    <div class="table-container">
      <div class="table">
        <div class="row header">
          <div class="cell header">
            {{$t('rank')}}
          </div>
          <div class="cell header">
            {{$t('families')}}
          </div>
          <div class="cell header">
            {{getMetric.label}}
          </div>
          <div class="cell header">
            {{$t('percentage')}}
          </div>
        </div>
        <div class="row"  v-for="(family, index) in this.getItems" v-if="family.key">
          <div class="cell rang" data-title="RANG">
            {{index + 1}}
          </div>
          <div class="cell" data-title="MARQUES">
            {{family.label}}
          </div>
          <div class="cell" data-title="FAMILLE">
            {{family[metricSelect.value].value | getKNumber | splitNumber}}
          </div>
          <div class="cell" data-title="POURCENTAGES">
            {{family.percentage}}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Famille',
    components: {
      Info
    },
    props: {
      result: Object,
      search: Object,
      top:Object,
      metric:Object
    },
    data() {
      return {
        fullscreen: false,
        info: {
         infoKey: this.getInfoKey()
        },
        metrics: [
          {value:'amountPostDiscountTtc', label:'CA TTC (en €)'},
          {value:'profBrandHt', label:'Marge HT (en €)'},
          {value:'quantities', label:"Quantité (en nombre d'articles)"}
        ],
        tops: [
          {value: 10, label: "Top 10"},
          {value: 20, label: "Top 20"},
          {value: 30, label: "Top 30"},
          {value: 50, label: "Top 50"},
        ]
      }
    },
    mounted() {
      //this.metric = this.metrics[0]
    },
    computed: {
      getItems: function () {
        if (!this.result || !this.metricSelect || !this.result.aggregations || !this.result.aggregations['to-bills'] || !this.result.aggregations['to-bills'].bills || !this.result.aggregations['to-bills'].bills.details || !this.result.aggregations['to-bills'].bills.details['filtered-results'])
          return []
        else {
          let met = this.metricSelect;
          let sel = this.topSelect;
          let key = 'family_code_' + met.value;
          if (this.result.aggregations['to-bills'].bills.details['filtered-results'][key]) {
            return this.result.aggregations['to-bills'].bills.details['filtered-results'][key].buckets.slice(0, sel.value)
          } else {
            return []
          }
        }
      },
      getMetric: function() {
        return this.metric || {label:''}
      },
      topSelect: {
        get: function(){
          return this.top || this.tops[0];
        },
        set: function(evt){
          this.$emit('changeTop',evt)
        }
      },
      metricSelect: {
        get: function(){
          return this.metric || this.metrics[0];
        },
        set: function(evt){
          this.$emit('changeMetric',evt)
        }
      },
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
      },
      getInfoKey() {
        let brand = this.search.query.businessUnit.substring(0,3);
        if (brand === 'NOR') {
          return "famille.norautoInfo";
        } else {
          return "famille.midasInfo";
        }
      },
      changeTop(evt) {
        this.$emit('changeTop',evt)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/famille.sass"
</style>
